






































import { defineComponent } from '@vue/composition-api';

import VueSelectWrapper from '@/components/molecules/VueSelectWrapper.vue';

import { useAdvisorSearchFormAutoComplete } from '@/modules/advisor-search/organisms/AdvisorSearchForm/AdvisorSearchFormAutoComplete';

export default defineComponent({
  name: 'AdvisorSearchFormAutoComplete',
  components: {
    VueSelectWrapper,
  },
  props: {
    name: {
      type: String,
      default: 'keyword',
    },
    placeholder: {
      type: String,
      default: 'キーワードを入力（例：化粧品 企画）',
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const { state, fetchSuggestions, select, input, mapKeydown } =
      useAdvisorSearchFormAutoComplete(props, context);

    return {
      state,
      fetchSuggestions,
      select,
      input,
      mapKeydown,
    };
  },
});
